"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBooleanArray = void 0;
const is_array_of_type_1 = require("./is-array-of-type");
exports.isBooleanArray = (value) => is_array_of_type_1.isArrayOfType(value, "boolean");
//# sourceMappingURL=is-boolean-array.js.map